import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';

export const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-50" data-testid="chat-widget">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.95 }}
            transition={{ duration: 0.2 }}
            className="absolute bottom-20 right-0 w-80 bg-white rounded-lg shadow-2xl border border-slate-200 overflow-hidden"
            data-testid="chat-widget-panel"
          >
            {/* Header */}
            <div className="bg-slate-900 p-4">
              <div className="flex items-center justify-between">
                <div>
                  <img 
                    src="https://customer-assets.emergentagent.com/job_b16acfe5-1235-44c1-ace5-482b8c36602b/artifacts/14ftomu2_Advanced-ADAS-w-logo-white-with-red-768x158.png"
                    alt="Advanced ADAS Calibrations"
                    className="h-8 w-auto mb-1"
                  />
                  <p className="text-slate-400 text-sm">
                    We typically reply within 1 hour
                  </p>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="text-slate-400 hover:text-white transition-colors"
                  aria-label="Close chat"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>
            </div>

            {/* Content */}
            <div className="p-4">
              <p className="text-slate-600 text-sm mb-4">
                Need help with ADAS calibration? Contact us directly:
              </p>

              <div className="space-y-3">
                <a
                  href="tel:0402454588"
                  className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-blue-50 transition-colors group"
                  data-testid="chat-widget-phone"
                >
                  <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                    <Phone className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <p className="text-slate-900 font-semibold text-sm">Call Us</p>
                    <p className="text-blue-600 text-sm">0402 454 588</p>
                  </div>
                </a>

                <a
                  href="mailto:sales@advancedadas.com.au"
                  className="flex items-center gap-3 p-3 bg-slate-50 rounded-lg hover:bg-blue-50 transition-colors group"
                  data-testid="chat-widget-email"
                >
                  <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                    <Mail className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <p className="text-slate-900 font-semibold text-sm">Email Us</p>
                    <p className="text-blue-600 text-sm">sales@advancedadas.com.au</p>
                  </div>
                </a>
              </div>

              <p className="text-slate-400 text-xs mt-4 text-center">
                Mon - Fri: 8am - 5pm
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Chat Button */}
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <Button
          onClick={() => setIsOpen(!isOpen)}
          className={`relative w-14 h-14 rounded-full shadow-lg transition-colors ${
            isOpen ? 'bg-slate-800 hover:bg-slate-700' : 'bg-blue-600 hover:bg-blue-700'
          }`}
          data-testid="chat-widget-toggle"
        >
          {!isOpen && (
            <span className="chat-pulse absolute inset-0 rounded-full" />
          )}
          <span className="relative z-10">
            {isOpen ? (
              <X className="w-6 h-6 text-white" />
            ) : (
              <MessageCircle className="w-6 h-6 text-white" />
            )}
          </span>
        </Button>
      </motion.div>
    </div>
  );
};
